import {
  faDownload,
  faEye,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./Imperiality_table.css";

import Imperiality_view_offcanvas from "../imperiality_view_offcanvas/Imperiality_view_offcanvas";
import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Imperiality_table() {
  const [view, setView] = useState(false);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);

  const data = [
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Upload file",
    },
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Upload file",
    },
    {
      employeeId: "CUST001",
      employeeName: "ABC Coal Traders",
      employeeDesignation: "Industry",
      attachedFile: "Empid1001.PDF",
    },
  ];

     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ✅ DELETE CONFIRM HANDLER */
  const handleDelete = () => {
    console.log("File deleted");
    setDelete(false);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Designation</th>
                  <th>Attached File</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.employeeId}</td>
                    <td>{row.employeeName}</td>
                    <td>{row.employeeDesignation}</td>

                    <td
                      className={`status attachedFileStatus ${
                        row.attachedFile === "Upload file"
                          ? "in_active"
                          : "active"
                      }`}
                    >
                      {row.attachedFile}
                    </td>

                    <td>
                      <div className="action_icons">
                        <FontAwesomeIcon
                          icon={faEye}
                          onClick={() => setView(true)}
                        />
                        <FontAwesomeIcon
                          icon={faDownload}
                          onClick={() => setDownload(true)}
                        />
                        <FontAwesomeIcon
                          icon={faTrashCan}
                          onClick={() => setDelete(true)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
         <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      </section>

      {/* VIEW */}
      <Imperiality_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
      />

      {/* DOWNLOAD */}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download File"
        massageText={"Confidentiality"}
      />

      {/* DELETE */}
      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete File"
        massageText={"Impartiality "}
      />
    </>
  );
}

export default Imperiality_table;
